import IService from '../IService';

export default IService.extend({
  abort() {
    if (app.xhrExpected(this.req)) {
      this.req.abort();
    }
  },

  /**
   * @param options
   * @return {Promise}
   */
  getUser(data) {
    data = Object.assign(
      {
        /** search query */
        context: 'user',
        query: null,
      },
      data
    );

    return new Promise((resolve, reject) => {
      this.req = $.ajax({
        url: 'https://www.instagram.com/web/search/topsearch/',
        type: 'GET',
        timeout: app.TIME.minute(),
        data,
        dataType: 'json',

        error(jqXHR, textStatus, errorThrown) {
          if ('abort' !== textStatus) {
            reject({ error: errorThrown });
          }
        },

        success(res) {
          if (res.users.length) {
            resolve(res.users[0].user);
          } else {
            reject();
          }
        },
      }).always(() => {
        this.req = null;
      });
    });
  },
});
